import React, { useState } from "react";
import { ToggleButtonGroup } from "@mui/material";
import ToggleButton from "@mui/material/ToggleButton";
import { isMobile, getDaysDifference } from "app/utils/utils";
import { updateDashboardFilter, updateDashboardFilterDates } from "app/store/slice/common-slice";
import { updateReportingFiltersDate } from "app/store/slice/report-slice"
import { dispatch } from "app/store/store";
import { useDispatch, useSelector } from "react-redux";
import { DateRangePicker, Stack } from 'rsuite';
import subDays from 'date-fns/subDays';
import startOfWeek from 'date-fns/startOfWeek';
import endOfWeek from 'date-fns/endOfWeek';
import addDays from 'date-fns/addDays';
import startOfMonth from 'date-fns/startOfMonth';
import endOfMonth from 'date-fns/endOfMonth';
import addMonths from 'date-fns/addMonths';
import {
  format,
} from "date-fns";


const DateFilters = () => {
  const { reportingFilters } = useSelector((state) => state.ReportReducer);

  //console.log('dashboardDateFilter', dashboardDateFilter)
  const handleChange = (event, value) => {
    if (value != "" && value != null) {
      dispatch(updateDashboardFilter(value));
    }
    if (value == "custom_date") {
      setShowPicker(true);
    } else {
      setShowPicker(false);
    }
  };

  const [showPicker, setShowPicker] = useState(false);
  const handleDateRangeChange = (value) => {
    // setShowPicker(false);
    // console.log("value is here ", getDaysDifference(value[1],value[0]))
    // dispatch(updateDashboardFilterDates({
    //   startDate:format(value[0],"yyyy-MM-dd HH:mm:ss"),
    //   endDate:format(value[1],"yyyy-MM-dd HH:mm:ss")
    // }))

    console.log("date", value)
    dispatch(updateReportingFiltersDate({
      start_date: format(value[0], "yyyy-MM-dd HH:mm:ss"),
      end_date: format(value[1], "yyyy-MM-dd HH:mm:ss")
    }))
  };

  const predefinedBottomRanges = [
    {
      label: 'Today',
      value: [new Date(), new Date()]
    },
    {
      label: 'Yesterday',
      value: [addDays(new Date(), -1), addDays(new Date(), -1)]
    },
    {
      label: 'This week',
      value: [startOfWeek(new Date()), endOfWeek(new Date())]
    },
    {
      label: 'Last 7 days',
      value: [subDays(new Date(), 6), new Date()]
    },
    {
      label: 'Last 30 days',
      value: [subDays(new Date(), 29), new Date()]
    },
    {
      label: 'This month',
      value: [startOfMonth(new Date()), new Date()]
    },
    {
      label: 'Last month',
      value: [startOfMonth(addMonths(new Date(), -1)), endOfMonth(addMonths(new Date(), -1))]
    }
  ];


  return (
    <>
      <DateRangePicker
        ranges={predefinedBottomRanges}
        placeholder="Placement defaults to bottom"
        style={{ width: 300 }}
        value={[new Date(reportingFilters.start_date), new Date(reportingFilters.end_date)]}
        onChange={handleDateRangeChange}
      />
      {/* <ToggleButtonGroup
        color="primary"
        value={dashboardDateFilter.label}
        exclusive
        onChange={handleChange}


      > */}
      {/* <ToggleButton
          sx={{
            textTransform: "capitalize",
            fontSize: isMobile() ? "11px" : "14px",
          }}
          value="day"
          size="small"
        >
          Day
        </ToggleButton> */}
      {/* <ToggleButton
          sx={{
            textTransform: "capitalize",
            fontSize: isMobile() ? "11px" : "14px",
          }}
          value="week"
          size="small"
        >
          Current Week
        </ToggleButton> */}
      {/* <ToggleButton
          sx={{
            textTransform: "capitalize",
            fontSize: isMobile() ? "11px" : "14px",
          }}
          value="last_week"
          size="small"
        >
          Last Week
        </ToggleButton>
        <ToggleButton
          sx={{
            textTransform: "capitalize",
            fontSize: isMobile() ? "11px" : "14px",
          }}
          value="last_month"
          size="small"
        >
          Last Month  
        </ToggleButton> */}
      {/* <ToggleButton
          sx={{
            textTransform: "capitalize",
            fontSize: isMobile() ? "11px" : "14px",
          }}
          value="custom_date"
          size="small"
        >
          Custom Date
          {showPicker && (
            <DateRangePicker
              open={showPicker}
              appearance="subtle"
              placeholder="Subtle"
              placement='autoVerticalStart'
              className="custom_date"
              style={{ width: 0, display: "none", zIndex: "100000" }}
              onChange={handleDateRangeChange}
            />
          )}
        </ToggleButton> */}
      {/* </ToggleButtonGroup> */}

    </>
  );
};

export default DateFilters;
